import { useImpersonation } from '@app/core/auth/impersonation';
import { impersonationMessages } from '@app/core/auth/impersonation/impersonation-messages';
import { Chip, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';

/**
 * Compact rail badge when impersonation comes from tab-scoped auth_as
 * (backoffice deep link) rather than the persisted impersonation store.
 */
export function SidenavTabAuthAsBadge() {
  const { isTabAuthAs } = useImpersonation();
  const { $t } = useIntl();

  if (!isTabAuthAs) {
    return null;
  }

  return (
    <Tooltip title={$t(impersonationMessages.tabAuthAsBadgeTooltip)} placement="bottom">
      <Chip
        size="small"
        label={$t(impersonationMessages.tabAuthAsBadgeLabel)}
        data-cy="sidenav-tab-auth-as-badge"
        sx={{
          height: 16,
          flexShrink: 0,
          bgcolor: 'warning.main',
          color: 'warning.contrastText',
          '& .MuiChip-label': {
            typography: 'caption',
            px: 0.5,
            lineHeight: 1,
          },
        }}
      />
    </Tooltip>
  );
}
